import React from 'react';
import ProductCard from './productCardV3';
import style from "./shopV3.module.css";
import { useRef } from 'react';

const ProductList = ({ products }) => {


  const productListRef = useRef(null);

  const scrollToProducts = () => {
    productListRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
 <>
 <div className={style.bannerShop}>
      <img src='/image/ar.png' className={style.desBannerShop}         onClick={scrollToProducts}
      />
      <img src='/image/arm.png' className={style.mobBannerShop}         onClick={scrollToProducts}
      />
 </div>
    <div className={style.productList}  ref={productListRef}>
      {/* Check if there are no matching products */}
      {products.length === 0 ? (
        <p className={style.noProductsMessage}>No products found. Please adjust your filters.</p>
      ) : (
        products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))
      )}
    </div>
 </>
  );
};

export default ProductList;
